import { render, staticRenderFns } from "./FundPensionInvestment.vue?vue&type=template&id=1adbd21a&scoped=true"
import script from "./FundPensionInvestment.vue?vue&type=script&lang=ts&setup=true"
export * from "./FundPensionInvestment.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./FundPensionInvestment.vue?vue&type=style&index=0&id=1adbd21a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adbd21a",
  null
  
)

export default component.exports